import { render } from "./ColleagueRegistration.vue?vue&type=template&id=24bfe388&scoped=true"
import script from "./ColleagueRegistration.vue?vue&type=script&lang=js"
export * from "./ColleagueRegistration.vue?vue&type=script&lang=js"

import "./ColleagueRegistration.vue?vue&type=style&index=0&id=24bfe388&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bfe388"]])

export default __exports__